// removed by extract-text-webpack-plugin
module.exports = {"logoContainer":"src-components-shared-link-headline-__shared-link-headline-module___logoContainer","logoImg":"src-components-shared-link-headline-__shared-link-headline-module___logoImg","presentationName":"src-components-shared-link-headline-__shared-link-headline-module___presentationName"};


//////////////////
// WEBPACK FOOTER
// ./src/components/shared-link-headline/shared-link-headline.module.css
// module id = 435
// module chunks = 52